var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"career-courseware-detail"},[(_vm.showDetail)?_c('show-detail',{attrs:{"main-data":_vm.mainData}}):_c('video-detail',{attrs:{"main-data":_vm.mainData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }